import React from "react";
import { Box } from "arkh";
import { RichDescriptionInputButton } from "../RichDescriptionInput";

export function LinkedContentToolbar(props: {
  openImagePicker?: () => void;
  openLinkProduct?: () => void;
  openLinkFile?: () => void;
  disabled?: boolean;
}) {
  return (
    <Box
      style={{ flexDirection: "row", justifyContent: "flex-end" }}
      space="medium"
      spaceRight="none"
    >
      {props.openImagePicker ? (
        <Box spaceRight="medium">
          <RichDescriptionInputButton
            disabled={props.disabled}
            type="image"
            onPress={() => {
              props.openImagePicker?.();
            }}
          />
        </Box>
      ) : null}
      {props.openLinkProduct ? (
        <Box spaceRight="medium">
          <RichDescriptionInputButton
            disabled={props.disabled}
            type="product"
            onPress={() => props.openLinkProduct?.()}
          />
        </Box>
      ) : null}
      {props.openLinkFile ? (
        <Box spaceRight="medium">
          <RichDescriptionInputButton
            disabled={props.disabled}
            type="files"
            onPress={() => {
              props.openLinkFile?.();
            }}
          />
        </Box>
      ) : null}
    </Box>
  );
}
